module.exports = __webpack_public_path__ + "static/media/fruit-icon-eggplant.a68dd104.jpg";